import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { Fragment, ReactNode } from 'react';
import { cn } from '../../utils/common-utils.ts';

interface ISelect {
  options: string[];
  onChange: (value: string) => void;
  value: string;
  className?: string;
  disabled?: boolean;
  renderOption?: (value: string) => ReactNode;
  renderValue?: (value: string) => ReactNode;
}

const Select = ({
  options,
  onChange,
  value,
  disabled,
  className = '',
  renderOption,
  renderValue,
}: ISelect) => {
  return (
    <Listbox value={value} onChange={onChange} disabled={disabled ?? false}>
      <div className="relative">
        <Listbox.Button
          className={cn(
            'relative w-fit cursor-pointer rounded-lg bg-light-gray py-2 pl-3 pr-10 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2',
            className,
          )}
        >
          <span className="block">
            {renderValue ? renderValue(value) : value}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon className="h-5 w-5" aria-hidden="true" />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base ring-1 ring-black/5 focus:outline-none sm:text-sm">
            {options.map((option) => (
              <Listbox.Option
                key={option}
                className={({ active }) =>
                  cn(
                    'relative cursor-default select-none py-2 pl-10 pr-4 text-black',
                    active && 'bg-light-blue',
                  )
                }
                value={option}
              >
                {({ selected }) => (
                  <>
                    <span className={cn('block', selected && 'font-medium')}>
                      {renderOption ? renderOption(option) : option}
                    </span>
                    {selected ? (
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    ) : null}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};
export default Select;
